import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


function PaymentLoading() {
    const navigate = useNavigate();
    const url = window.location.search;

    const verifyPayment = async(url) => {
        const  postOptions = {
            method : "POST",
            headers: {
              "Content-Type" : "application/json",
             }
        };
        await fetch(`${process.env.REACT_APP_API_URL}/payment/verify-payment${url}`, postOptions)
        .then(response => response.json())
        .then(data => {
          console.log(data)
            if(data.msg === 'success'){
              navigate('/successful')
            }else{
                setTimeout(()=> {
                    navigate(-5)
                   }, 3000)
                   navigate('/failed')
            }
        })
        .catch(err => console.log(err))
      }

   useEffect(()=> {
     setTimeout(() => {
        verifyPayment(url)
     }, 5000)
   }, [])

  return (
    <div className="loading-container">
        <img className='loading-gif' src="https://vafloc01.s3.amazonaws.com/WBStatic/site1102601/dist/img/loader.gif" alt="gif" />
        </div>
  )
}

export default PaymentLoading